import React from 'react';
import ErrorGridItem from './ErrorGridItem';

/**
 * Error Boundary for a GridItem component. Will catch any errors and raise
 * them with the {CommunityGridItem}.
 */
interface Props {
  children: React.ReactElement;
}

interface State {
  hasError: boolean;
}

export class GridItemErrorBoundary extends React.Component<Props, State> {
  state: State = {
    hasError: false,
  };

  render() {
    if (this.state.hasError) {
      return <ErrorGridItem />;
    }

    return this.props.children;
  }
}
